import { render } from "./LowStockAlerts.vue?vue&type=template&id=7670b3be&scoped=true&ts=true"
import script from "./LowStockAlerts.vue?vue&type=script&lang=ts"
export * from "./LowStockAlerts.vue?vue&type=script&lang=ts"

import "./LowStockAlerts.vue?vue&type=style&index=0&id=7670b3be&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7670b3be"]])

export default __exports__